import { render } from "./StoreData.vue?vue&type=template&id=67950cf7&scoped=true"
import script from "./StoreData.vue?vue&type=script&lang=js"
export * from "./StoreData.vue?vue&type=script&lang=js"

import "./StoreData.vue?vue&type=style&index=0&id=67950cf7&scoped=true&lang=css"
import "./StoreData.vue?vue&type=style&index=1&id=67950cf7&lang=less&scoped=true"
import "./StoreData.vue?vue&type=style&index=2&id=67950cf7&lang=less&scoped=true"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67950cf7"]])

export default __exports__